import type { IgnoreError } from '@inflearn/monitoring';

export const ignoreErrors: IgnoreError[] = [
  { message: 'Network Error', stack: undefined },
  { message: 'Load failed', stack: undefined },
  { message: 'TypeError: Load failed', stack: undefined },
  { message: 'Failed to fetch', stack: undefined },
  { message: 'TypeError: Failed to fetch', stack: undefined },
  { message: 'console error: TypeError: Failed to fetch', stack: undefined },
  { message: 'console error: TypeError: Load failed', stack: undefined },
  { message: 'NetworkError when attempting to fetch resource.', stack: undefined },
  { message: 'The network connection was lost.', stack: undefined },
  { message: '네트워크 연결이 유실되었습니다.', stack: undefined },
  {
    message: 'The operation couldn’t be completed. Software caused connection abort',
    stack: undefined,
  },
  { message: '작업을 완료할 수 없습니다. 소프트웨어에 의한 연결 중단', stack: undefined },
  { message: 'WebKit encountered an internal error', stack: undefined },
  { message: 'The Internet connection appears to be offline.', stack: undefined },
  {
    message:
      'Non-Error promise rejection captured with keys: currentTarget, isTrusted target, type',
    stack: undefined,
  },
  { message: '취소됨', stack: undefined },
  { message: 'cannot parse response', stack: undefined },
  { message: 'Network request failed', stack: undefined },
  { message: 'Loading chunk', stack: undefined },
  { message: 'Loading CSS chunk', stack: undefined },
  { message: 'Could not connect to the server', stack: undefined },
  { message: 'An SSL error has occurred', stack: undefined },
  { message: 'checkDomStatus', stack: undefined },
  { message: 'ResizeObserver loop completed with undelivered notifications.', stack: undefined },
  { message: 'Uncaught "ResizeObserver loop limit exceeded"', stack: undefined },
  { message: 'Uncaught "Object Not Found Matching Id:"', stack: undefined },
  {
    message: 'from accessing a cross-origin frame. Protocols, domains, and ports must match.',
    stack: undefined,
  }, // 웨일, iframe 에러
];

export const IGNORE_RESOURCE_URLS = [
  /**
   * 운영적으로 크게 문제 되는 에러가 아님에도 불구하고 에러가 자주 발생해 무시 처리
   * 관련 스레드 @see {@link https://inflab-team.slack.com/archives/CHK5LNM6Z/p1721981588271869}
   */
  'linkedin',
  'hackle',
] as const;
